import { useEffect, useState } from "react";
import { Lock, Unlock } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useEditor } from "@/components/editor/useEditorState";

const list = (pages) => (pages.length > 4 ? `${pages.slice(0, 4).join(", ")} e altre ${pages.length - 4}` : pages.join(", ") || "nessuna");

export default function SharedLock({ on, setOn }) {
  const { api, id } = useEditor();
  const [impact, setImpact] = useState(null);
  useEffect(() => { if (on) api.get(`/projects/${id}/ai-edits/impact`).then(({ data }) => setImpact(data)).catch(() => {}); }, [on, api, id]);
  return (
    <div className={`rounded-lg border p-2.5 ${on ? "border-amber-300 bg-amber-50" : "border-slate-200 bg-slate-50"}`} data-testid="ai-shared-lock">
      <label className="flex items-center justify-between gap-2 text-xs text-slate-700">
        <span className="inline-flex items-center gap-1.5 font-medium">{on ? <Unlock size={13} className="text-amber-700" /> : <Lock size={13} className="text-slate-500" />}Sblocca elementi condivisi</span>
        <Switch checked={on} onCheckedChange={setOn} data-testid="ai-unlock-shared-switch" />
      </label>
      {!on && <p className="mt-1 text-[11px] text-slate-500">Header, footer, dati simulati, design e CSS globale sono bloccati: l'AI non può modificarli.</p>}
      {on && impact && (
        <ul className="mt-2 space-y-1 text-[11px] text-amber-900" data-testid="ai-shared-impact">
          {Object.entries(impact.components).filter(([, v]) => v.pages.length).map(([n, v]) => <li key={n}><b>{n}</b> ({v.placement === "none" ? "riutilizzabile" : v.placement}) → {v.pages.length} pagine: {list(v.pages)}</li>)}
          <li><b>Dati simulati (DATA)</b> → {impact.data.length} pagine: {list(impact.data)}</li>
          <li><b>Design e CSS globale</b> → tutte le {impact.design.length} pagine</li>
        </ul>
      )}
    </div>
  );
}
